
import calander from "./components/Calendar.vue";
export default{
  install(Vue){
    Vue.component("calander", calander);

  }
};



